import Vue from "vue";
import Vuex from "vuex";
import {
  SET_QUERY,
  SET_SORT,
  SET_TOOLBAR,
  TOGGLE_DRAWER,
  SET_TAGS,
  TOGGLE_TAG,
  SET_DATA
} from "./action-types";
import { tagGroup } from "@/utils/TagUtils";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    toolbar: {
      title: "Recepty",
      overContent: false,
      filter: false,
      search: false,
      menu: []
    },
    sort: {
      name: "order",
      direction: "desc"
    },
    filter: {
      tags: [],
      query: ""
    },
    data: []
  },
  getters: {
    tags(state) {
      const tags = new Set();
      state.data.forEach(recipe =>
        (recipe.tags || []).forEach(tag => tags.add(tag))
      );
      return [...tags].sort();
    },
    tagGroups(state, getters) {
      return getters.tags.reduce((groups, tag) => {
        const group = tagGroup(tag);
        return {
          ...groups,
          [group]: [...(groups[group] || []), tag]
        };
      }, {});
    },
    recipeByUrl: state => url => state.data.find(recipe => recipe.url === url)
  },
  mutations: {
    [TOGGLE_DRAWER](state, value) {
      state.drawer = !!value;
    },
    [SET_TOOLBAR](state, toolbar) {
      state.toolbar = toolbar;
    },
    [SET_TAGS](state, tags) {
      state.filter.tags = tags;
    },
    [TOGGLE_TAG](state, tag) {
      if (state.filter.tags.includes(tag)) {
        // Remove tag
        state.filter.tags = state.filter.tags.filter(t => t !== tag);
      } else {
        // Add tag
        state.filter.tags = [...state.filter.tags, tag];
      }
    },
    [SET_SORT](state, sort) {
      state.sort = sort;
    },
    [SET_DATA](state, data) {
      state.data = data;
    },
    [SET_QUERY](state, query) {
      state.filter.query = query;
    }
  },
  actions: {
    [TOGGLE_DRAWER]({ commit, state }, value) {
      commit(TOGGLE_DRAWER, value !== undefined ? value : !state.drawer);
    }
  }
});
